import { Component, computed, inject, LOCALE_ID, signal, OnInit, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { FilterDateComponent } from '../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterInput } from '../../../../shared/ui/shared-filters/filter-input/filter-input';
import { FilterSelectComponent } from '../../../../shared/ui/shared-filters/filter-select-component/filter-select-component';
import { FilterSortingComponent } from '../../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';
import { FilterItemSearch } from '../../../../shared/ui/shared-filters/filter-item-search/filter-item-search';

import { Tables } from '../../../../shared/ui/shared-tables/tables/tables';
import { Pagination } from '../../../../shared/ui/shared-tables/pagination/pagination';
import { ActionIcon } from '../../../../shared/ui/icons/action-icon/action-icon';
import {
  ActionInterface,
  PartiallyDeliveredReason,
} from '../../../../pages/admin-dashboard/partially-delivered-reasons/partiallyDeliveredReason.model';
import { ConfirmationDialog } from '../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { PartiallyDeliveredReasonsService } from '../../../../services/partially-delivered-reasons/partially-delivered-reasons.service';
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../services/scope/scope-constants';
import { ScopeService } from '../../../../services/scope/scope-service';
import { validateInvoiceDates } from '../../invoice-list-component/invoice-list-component.validation';
import { SubmitButton } from "../../../../shared/ui/Buttons/submit-button/submit-button";
import { ErrorData } from "../../../../utils/error-data/error-data";
import { Loading } from "../../../../utils/loading/loading";

@Component({
  selector: 'app-partially-delivered-reasons-list-component',
  standalone: true,
  imports: [
    FormsModule,
    FilterInput,
    FilterDateComponent,
    FilterSelectComponent,
    FilterSortingComponent,
    FilterItemSearch,
    Tables,
    ActionIcon,
    Pagination,
    ConfirmationDialog,
    HasScopeDirective,
    SubmitButton,
    ErrorData,
    Loading
],
  templateUrl: './partially-delivered-reasons-list-component.html',
  styleUrl: './partially-delivered-reasons-list-component.scss',
})
export class PartiallyDeliveredReasonsListComponent implements OnInit {
  public locale = inject(LOCALE_ID);
  readonly SCOPES = SCOPES;
  private scopeService = inject(ScopeService);
   private destroyRef = inject(DestroyRef);

  private router = inject(Router);
  private reasonService = inject(PartiallyDeliveredReasonsService);

  searchLabel = $localize`:@@partiallyDeliveredReasonsSearchLabel:Search`;

  searchPlaceholder = $localize`:@@partiallyDeliveredReasonsSearchPlaceholder:Search by reason name`;

  createdFromLabel = $localize`:@@partiallyDeliveredReasonsCreatedFrom:Created On From`;

  createdToLabel = $localize`:@@partiallyDeliveredReasonsCreatedTo:Created On To`;

  modifiedFromLabel = $localize`:@@partiallyDeliveredReasonsModifiedFrom:Last Modified From`;

  modifiedToLabel = $localize`:@@partiallyDeliveredReasonsModifiedTo:Last Modified To`;

  tableTitle = $localize`:@@partiallyDeliveredReasonsTableTitle:Reason`;

  tableType = $localize`:@@partiallyDeliveredReasonsTableType:Type`;

  tableCreatedOn = $localize`:@@partiallyDeliveredReasonsTableCreatedOn:Created On / By`;

  tableLastModified = $localize`:@@partiallyDeliveredReasonsTableLastModified:Last Modified On / By`;

search = signal('');

createdFrom = signal<string | null>(null);
createdTo = signal<string | null>(null);

modifiedFrom = signal<string | null>(null);
modifiedTo = signal<string | null>(null);

// orderBy = signal<'TITLE' | 'CREATION_DATE' | 'LAST_MODIFIED_ON'>(
//   'CREATION_DATE'
// );
orderBy = signal<
  'TITLE' | 'CREATION_DATE' | 'LAST_MODIFICATION_DATE'
>('CREATION_DATE');

orderDir = signal<'ASC' | 'DESC'>('DESC');

currentPage = signal(1);
itemsPerPage = signal(25);


reasons = signal<PartiallyDeliveredReason[]>([]);
  // sortOptions = [
  //   {
  //     value: 'TITLE',
  //     labelEn: 'Reason',
  //     labelAr: 'السبب',
  //   },
  //   {
  //     value: 'CREATION_DATE',
  //     labelEn: 'Created On',
  //     labelAr: 'تاريخ الإنشاء',
  //   },
  //   {
  //     value: 'LAST_MODIFIED_ON',
  //     labelEn: 'Last Modified',
  //     labelAr: 'آخر تعديل',
  //   },
  // ];
 sortOptions = [
  { value: 'TITLE', labelEn: 'Reason', labelAr: 'السبب' },
  { value: 'CREATION_DATE', labelEn: 'Created On', labelAr: 'تاريخ الإنشاء' },
  {
    value: 'LAST_MODIFICATION_DATE',
    labelEn: 'Last Modified',
    labelAr: 'آخر تعديل',
  },
];
  totalItemsFromApi = signal(0);

  showDeleteDialog = signal(false);

  reasonToDelete = signal<PartiallyDeliveredReason | null>(null);

  deleteTitle = $localize`:@@partiallyDeliveredReasonsDeleteTitle:Delete Reason`;

  deleteDescriptionAr = 'هل انت متأكد من رغبتك في حذف سبب التسليم الجزئي؟';

  deleteDescriptionEn = 'Are you sure you want to delete this partially delivered reason?';

  deleteButton = $localize`:@@delete:Delete`;

  cancelButton = $localize`:@@cancel:Cancel`;

  deleteError = signal('');
  ngOnInit() {
    this.loadReasons();
  }

    isArabic = computed(() => this.locale.startsWith('ar'));

    lang = computed<'ar' | 'en'>(() =>
  this.isArabic() ? 'ar' : 'en'
);

loadReasons() {
  this.loading.set(true);
  this.errorMessage.set(null);

  const subscription = this.reasonService
    .getAllReasons(this.lang(), {
      quickSearch: this.search() || undefined,

      pageNum: this.currentPage() - 1,
      pageSize: this.itemsPerPage(),

      orderBy: this.orderBy(),
      orderDir: this.orderDir(),

      createdOnFrom:
        this.createdFrom() || undefined,

      createdOnTo:
        this.createdTo() || undefined,

      lastModifiedOnFrom:
        this.modifiedFrom() || undefined,

      lastModifiedOnTo:
        this.modifiedTo() || undefined,
    })
    .subscribe({
      next: (res) => {
        if (!res) {
          this.reasons.set([]);
          this.totalItemsFromApi.set(0);
          this.loading.set(false);
          return;
        }

        const mappedReasons: PartiallyDeliveredReason[] =
          res.list.map((item) => ({
            id: item.id,

            titleEn: item.titleEn,
            titleAr: item.titleAr,

            isEditable: item.is_editable,

            createdOn: item.createdOn,

            createdBy:
              item.createdBy?.fullName,

            modifiedOn:
              item.lastModifiedOn,

            modifiedBy:
              item.lastModifiedBy?.fullName,
          }));

        this.reasons.set(mappedReasons);

        this.totalItemsFromApi.set(
          res.total
        );

        this.errorMessage.set(null);

        this.loading.set(false);
      },

      error: (error) => {
        console.error(
          'Error loading partially delivered reasons:',
          error
        );

        this.reasons.set([]);

        this.totalItemsFromApi.set(0);

        this.loading.set(false);

        this.errorMessage.set(
          this.isArabic()
            ? 'حدث خطأ أثناء تحميل البيانات.'
            : 'Something went wrong while loading data.'
        );
      },
    });

  this.destroyRef.onDestroy(() =>
    subscription.unsubscribe()
  );
}
  // getDisplayedReasons() {
  //   let data = [...this.reasons()];

  //   const direction = this.orderDir() === 'ASC' ? 1 : -1;

  //   data.sort((a, b) => {
  //     switch (this.filters().orderBy) {
  //       case 'TITLE':
  //         const titleA = this.locale.startsWith('ar') ? a.titleAr : a.titleEn;

  //         const titleB = this.locale.startsWith('ar') ? b.titleAr : b.titleEn;

  //         return titleA.localeCompare(titleB) * direction;

  //       case 'CREATED_ON':
  //         return (new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()) * direction;

  //       case 'LAST_MODIFIED_ON':
  //         return (new Date(a.modifiedOn ?? 0).getTime() - new Date(b.modifiedOn ?? 0).getTime()) * direction;

  //       default:
  //         return 0;
  //     }
  //   });

  //   if (this.filters().search) {
  //     const search = this.filters().search.toLowerCase();

  //     data = data.filter((item) => item.titleEn.toLowerCase().includes(search) || item.titleAr.includes(search));
  //   }

  //   return data;
  // }

toggleSortOrder() {
  this.orderDir.update((value) =>
    value === 'ASC' ? 'DESC' : 'ASC'
  );

  this.currentPage.set(1);
  this.loadReasons();
}
 loading = signal(true);
errorMessage = signal<string | null>(null);

createdFromError = signal<string | null>(null);
createdToError = signal<string | null>(null);

modifiedFromError = signal<string | null>(null);
modifiedToError = signal<string | null>(null);



validateDates(): boolean {
  const createdResult = validateInvoiceDates(
    this.createdFrom(),
    this.createdTo(),
    this.isArabic()
  );

  const modifiedResult = validateInvoiceDates(
    this.modifiedFrom(),
    this.modifiedTo(),
    this.isArabic()
  );

  this.createdFromError.set(createdResult.fromDateError);
  this.createdToError.set(createdResult.toDateError);

  this.modifiedFromError.set(modifiedResult.fromDateError);
  this.modifiedToError.set(modifiedResult.toDateError);

  return createdResult.isValid && modifiedResult.isValid;
}
applyFilters() {
  if (!this.validateDates()) {
    return;
  }

  this.currentPage.set(1);
  this.loadReasons();
}

resetFilters() {
  this.search.set('');

  this.createdFrom.set(null);
  this.createdTo.set(null);

  this.modifiedFrom.set(null);
  this.modifiedTo.set(null);

  this.createdFromError.set(null);
  this.createdToError.set(null);

  this.modifiedFromError.set(null);
  this.modifiedToError.set(null);

  this.orderBy.set('CREATION_DATE');
  this.orderDir.set('DESC');

  this.currentPage.set(1);

  this.loadReasons();
}
updateSearch(value: string) {
  this.search.set(value);
}

  updateCreatedFrom(value: string | null) {
  this.createdFrom.set(value);

  this.createdFromError.set(null);
  this.createdToError.set(null);
}

updateCreatedTo(value: string | null) {
  this.createdTo.set(value);

  this.createdFromError.set(null);
  this.createdToError.set(null);
}

updateModifiedFrom(value: string | null) {
  this.modifiedFrom.set(value);

  this.modifiedFromError.set(null);
  this.modifiedToError.set(null);
}

updateModifiedTo(value: string | null) {
  this.modifiedTo.set(value);

  this.modifiedFromError.set(null);
  this.modifiedToError.set(null);
}
updateOrderBy(
  value: 'TITLE' | 'CREATION_DATE' | 'LAST_MODIFICATION_DATE'
) {
  this.orderBy.set(value);
  this.currentPage.set(1);
  this.loadReasons();
}

  headerItems = computed(() => [
    {
      key: 'index',
      label: '#',
    },

    {
      key: 'title',
      label: this.tableTitle,
    },

    {
      key: 'type',
      label: this.tableType,
      type: 'status',
    },

    {
      key: 'createdOnBy',
      label: this.tableCreatedOn,
    },

    {
      key: 'lastModifiedOnBy',
      label: this.tableLastModified,
    },

    {
      key: 'actions',
      label: '',
      type: 'actions',
    },
  ]);

  actions: ActionInterface[] = [
    {
      id: 1,
      titleEn: 'Edit',
      titleAr: 'تعديل',
      scope: String(SCOPES.PARTIALLY_DELIVERED_REASONS.UPDATE),
    },
    {
      id: 2,
      titleEn: 'Delete',
      titleAr: 'حذف',
      scope: String(SCOPES.PARTIALLY_DELIVERED_REASONS.DELETE),
    },
  ];

  getActions(row: PartiallyDeliveredReason): ActionInterface[] {
    if (!row.isEditable) {
      return [];
    }

    return this.actions.filter((action) => {
      if (action.id === 1) {
        return this.scopeService.hasScope(SCOPES.PARTIALLY_DELIVERED_REASONS.UPDATE);
      }

      if (action.id === 2) {
        return this.scopeService.hasScope(SCOPES.PARTIALLY_DELIVERED_REASONS.DELETE);
      }

      return false;
    });
  }
isFiltersApplied = computed(() => {
  return !!(
    this.search() ||
    this.createdFrom() ||
    this.createdTo() ||
    this.modifiedFrom() ||
    this.modifiedTo()
  );
});
  // getActions(row: PartiallyDeliveredReason) {

  //   if (!row.isEditable) {

  //     return [];

  //   }

  //   return this.actions;

  // }
tableRows = computed(() => {
  return this.reasons().map((item, index) => ({
    id: item.id,

    index:
      (this.currentPage() - 1) *
        this.itemsPerPage() +
      index +
      1,

    title: this.locale.startsWith('ar')
      ? item.titleAr
      : item.titleEn,

    titleAr: item.titleAr,
    titleEn: item.titleEn,

    type: {
      titleEn: item.isEditable
        ? 'Custom'
        : 'System-defined',

      titleAr: item.isEditable
        ? 'مخصص'
        : 'معرف من النظام',
    },

    createdOn: item.createdOn,

    createdBy: item.isEditable
      ? item.createdBy
      : 'System',

    lastModifiedOn: item.modifiedOn,

    lastModifiedBy:
      item.modifiedBy ?? null,

    isEditable: item.isEditable,
  }));
});

  handleAction(event: any) {
    const row = event.entity;

    if (!row.isEditable) {
      return;
    }

    // Edit
    if (event.actionId === 1) {
      if (!this.scopeService.hasScope(SCOPES.PARTIALLY_DELIVERED_REASONS.UPDATE)) {
        return;
      }

      this.router.navigate(['/admin/partially-delivered-reasons/edit-partially-delivered-reason', row.id], {
        state: {
          id: row.id,
          titleAr: row.titleAr,
          titleEn: row.titleEn,
          isEditable: row.isEditable,
        },
      });
    }

    // Delete
    if (event.actionId === 2) {
      if (!this.scopeService.hasScope(SCOPES.PARTIALLY_DELIVERED_REASONS.DELETE)) {
        return;
      }

      this.openDeleteDialog(row);
    }
  }

  openDeleteDialog(reason: PartiallyDeliveredReason) {
    this.reasonToDelete.set(reason);
    this.deleteError.set('');

    this.showDeleteDialog.set(true);
  }

  closeDeleteConfirmation() {
    this.showDeleteDialog.set(false);
    this.reasonToDelete.set(null);
    this.deleteError.set('');
  }

  // deleteReason() {

  //   if (!this.reasonToDelete) {

  //     return;

  //   }

  //   this.reasons = this.reasons.filter(

  //     reason => reason.id !== this.reasonToDelete!.id

  //   );

  //   this.closeDeleteDialog();

  // }

  confirmDelete() {
    const reason = this.reasonToDelete();

    if (!reason) {
      return;
    }

    this.reasonService.deleteReason(reason.id).subscribe({
      next: () => {
        this.closeDeleteConfirmation();

        this.loadReasons();
      },

      error: (err) => {
        console.error('Error deleting partially delivered reason:', err);

        this.deleteError.set(
          err?.messageEn ||
            (this.locale.startsWith('ar') ? 'حدث خطأ أثناء حذف السبب' : 'An error occurred while deleting the reason'),
        );
      },
    });
  }
  // ================= Pagination =================

pagedRows = computed(() => this.tableRows());

totalPages = computed(() =>
  Math.ceil(
    this.totalItemsFromApi() /
    this.itemsPerPage()
  )
);

startItem = computed(() =>
  this.totalItemsFromApi()
    ? (this.currentPage() - 1) *
        this.itemsPerPage() +
      1
    : 0
);

endItem = computed(() =>
  Math.min(
    this.currentPage() *
      this.itemsPerPage(),
    this.totalItemsFromApi()
  )
);

  get totalItems() {
    return this.totalItemsFromApi();
  }

getPageNumbers() {
  const pages: number[] = [];

  for (
    let i = 1;
    i <= this.totalPages();
    i++
  ) {
    pages.push(i);
  }

  return pages;
}
onPreviousPage() {
  if (this.currentPage() > 1) {
    this.currentPage.update(
      (page) => page - 1
    );

    this.loadReasons();
  }
}

onNextPage() {
  if (
    this.currentPage() <
    this.totalPages()
  ) {
    this.currentPage.update(
      (page) => page + 1
    );

    this.loadReasons();
  }
}

onGoToPage(page: number) {
  this.currentPage.set(page);
  this.loadReasons();
}

onChangePageNumber(size: number) {
  this.itemsPerPage.set(+size);
  this.currentPage.set(1);
  this.loadReasons();
}

onPageSizeChange() {
  this.currentPage.set(1);
}
}
